export default {
  metadata: {
    version: '1.0.0',
    id: 'modal-mobile-1.0.0',
    name: 'JDSModalMobileInternal'
  },
  hierarchy: {
    container: [
      'overlay-container',
      {
        'outer-container': [
          {
            'root-container': [
              {
                'cancel-container': ['cancel-jds_button']
              },
              {
                'vertical-container': [
                  {
                    'header-container': ['header-jds-text']
                  },
                  {
                    'children-container': ['children-slot']
                  },
                  {
                    'button-container': [
                      'primary-jds_action_button',
                      'secondary-jds_action_button'
                    ]
                  }
                ]
              }
            ]
          },
          {
            'custom-container': ['children-slot']
          }
        ]
      }
    ]
  },
  base: {
    container: {
      'flex-direction': '{flexDirection.stack}',
      'justify-content': '{justifyContent.center}',
      'align-items': '{alignItems.center}',
      size: '{size.max}'
    },
    'overlay-container': {
      show: true,
      size: '{size.max}',
      'background-color': '{global.black}',
      opacity: '{custom_2}'
    },
    'outer-container': {
      'z-index': 1,
      'flex-direction': '{flexDirection.row}',
      'justify-content': '{justifyContent.center}',
      'align-items': '{alignItems.center}',
      'max-height': '{size.max}',
      width: '{size.max}',
      'padding-top': '{m}',
      'padding-bottom': '{m}',
      'padding-left': '{m}',
      'padding-right': '{m}'
    },
    'root-container': {
      'flex-direction': '{flexDirection.column}',
      'justify-content': '{justifyContent.start}',
      'align-items': '{alignItems.start}',
      'border-radius': '{xl}',
      width: '{size.max}',
      'background-color': '{elevation1}'
    },
    'cancel-container': {
      'flex-direction': '{flexDirection.row}',
      'justify-content': '{justifyContent.end}',
      'align-items': '{alignItems.center}',
      width: '{size.max}',
      'padding-top': '{s}',
      'padding-bottom': '{s}',
      'padding-left': '{s}',
      'padding-right': '{s}',
      hidden: false
    },
    'cancel-jds_button': {
      hidden: false,
      icon: 'ic_close',
      kind: 'tertiary',
      size: 'medium'
    },
    'vertical-container': {
      'flex-direction': '{flexDirection.column}',
      'justify-content': '{justifyContent.start}',
      'align-items': '{alignItems.start}',
      width: '{size.max}',
      'padding-left': '{l}',
      'padding-right': '{l}',
      'padding-bottom': '{l}',
      overflow: 'auto'
    },
    'header-container': {
      'flex-direction': '{flexDirection.row}',
      'justify-content': '{justifyContent.start}',
      'align-items': '{alignItems.center}',
      width: '{size.max}',
      'padding-bottom': '{base}'
    },
    'children-container': {
      width: '{size.max}',
      overflow: 'auto',
      'flex-fill-android': false
    },
    'button-container': {
      width: '{size.max}',
      'justify-content': '{justifyContent.start}',
      'align-items': '{alignItems.start}',
      'flex-direction': '{flexDirection.column}',
      gap: '{s}',
      'padding-top': '{base}'
    },
    'primary-jds_action_button': {
      hidden: false,
      kind: 'primary',
      size: 'large',
      stretch: true
    },
    'secondary-jds_action_button': {
      hidden: false,
      kind: 'secondary',
      size: 'large',
      stretch: true
    },
    'custom-container': {
      hidden: true,
      'flex-direction': '{flexDirection.column}',
      'justify-content': '{justifyContent.start}',
      'align-items': '{alignItems.start}',
      'border-radius': '{xl}',
      'background-color': '{elevation1}',
      'padding-left': '{l}',
      'padding-right': '{l}',
      'padding-top': '{l}',
      'padding-bottom': '{l}',
      width: '{size.max}'
    },
    'header-jds-text': {
      'font-family': '{text_86}',
      color: '{text_20}',
      'font-size': '{text_85}',
      'line-height': '{text_87}',
      'letter-spacing': '{text_88}',
      'font-weight': '{text_89}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {
    kind: {
      acknowledgement: {
        'primary-jds_action_button': {
          stretch: true
        },
        'secondary-jds_action_button': {
          hidden: true
        },
        'header-jds-text': {
          'text-align': 'center',
          flex: 1
        }
      },
      informational: {
        'button-container': {
          hidden: true
        }
      },
      custom: {
        'custom-container': {
          hidden: false
        },
        'root-container': {
          hidden: true
        }
      }
    },
    headerAlignment: {
      right: {
        'header-container': {
          'justify-content': '{justifyContent.end}'
        }
      },
      center: {
        'header-container': {
          'justify-content': '{justifyContent.center}'
        }
      }
    },
    size: {
      small: {
        'vertical-container': {
          'padding-left': '{m}',
          'padding-right': '{m}',
          'padding-bottom': '{m}'
        }
      }
    },
    primaryCtaDisabled: {
      true: {
        'primary-jds_action_button': {
          state: 'disabled'
        }
      }
    },
    secondaryCtaDisabled: {
      true: {
        'secondary-jds_action_button': {
          state: 'disabled'
        }
      }
    },
    _hasCta: {
      false: {
        'button-container': {
          hidden: true
        }
      }
    }
  },
  combination: [
    {
      dialog: {
        false: {
          'cancel-container': {
            hidden: true
          },
          'vertical-container': {
            'padding-top': '{l}'
          }
        }
      },
      acknowledgement: {
        false: {
          'cancel-container': {
            hidden: true
          },
          'vertical-container': {
            'padding-top': '{l}'
          }
        }
      }
    }
  ],
  combination_config: [['kind', 'isCloseable']],
  api: {
    config: {
      kind: {
        values: ['dialog', 'acknowledgement', 'informational', 'custom']
      },
      size: {
        values: ['medium', 'small']
      },
      headerAlignment: {
        values: ['left', 'right', 'center']
      },
      isCloseable: {
        values: [true, false]
      },
      primaryCtaDisabled: {
        values: [false, true]
      },
      secondaryCtaDisabled: {
        values: [false, true]
      },
      _hasCta: {
        values: [true, false]
      }
    },
    data: {
      'primary-jds_action_button': {
        label: {
          type: 'string',
          name: 'primaryCTA'
        }
      },
      'secondary-jds_action_button': {
        label: {
          type: 'string',
          name: 'secondaryCTA'
        }
      },
      'header-jds-text': {
        value: {
          type: 'string',
          name: 'header'
        }
      }
    },
    children: {
      'children-slot': {
        name: 'children',
        accepts: ['any'],
        max: 1,
        doc_description: 'This sets Modal content as a children elements.'
      }
    },
    events: {
      'root-container': {
        onClick: 'onModalClick'
      },
      'cancel-jds_button': {
        onClick: 'onCancel'
      },
      'primary-jds_action_button': {
        onClick: 'onPrimaryClick'
      },
      'secondary-jds_action_button': {
        onClick: 'onSecondaryClick'
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'dialog'
          },
          'aria-label': {
            name: 'ariaLabel',
            value: 'Modal Content'
          },
          'aria-modal': {
            name: '_ariaModal',
            value: 'true'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'cancel-jds_button': {
        properties: {
          ariaLabel: {
            name: 'cancelButtonCtaAriaLabel',
            value: 'Close Modal'
          }
        }
      },
      'primary-jds_action_button': {
        properties: {
          ariaLabel: 'primaryCtaAriaLabel',
          ariaDescribedby: {
            name: 'primaryCtaAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'secondary-jds_action_button': {
        properties: {
          ariaLabel: 'secondaryCtaAriaLabel',
          ariaDescribedby: {
            name: 'secondaryCtaAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
